/* @flow */

export default class MissingDocNote {
  missingDocType: string;
  missingDocNote: string;
}
